import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DocumentationImportKindEnum } from 'graphql-common';
import IconButton, {
  IconButtonSizes,
  IconButtonTypes,
} from '@lib/components/IconButton/IconButton';
import LinkComponent, { LinkSizes, LinkTypes } from '@lib/components/Link/Link';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import Typography from '@lib/components/Typography/Typography';
import FtpHowItWorksModal from '../FtpHowItWorksModal';
import styles from './SourceKindCaption.module.scss';

interface Props {
  sourceKind: DocumentationImportKindEnum;
}

const HINT_KEY: Record<DocumentationImportKindEnum, string> = {
  [DocumentationImportKindEnum.Files]: 'documents-import-source-files-hint',
  [DocumentationImportKindEnum.Archive]: 'documents-import-source-archive-hint',
  [DocumentationImportKindEnum.Ftp]: 'documents-import-source-ftp-hint',
};

export default function SourceKindCaption({ sourceKind }: Props) {
  const { t } = useTranslation();
  const [isHelpOpen, setHelpOpen] = useState(false);
  const hintKey = HINT_KEY[sourceKind];
  if (!hintKey) return null;

  const isFtp = sourceKind === DocumentationImportKindEnum.Ftp;

  return (
    <>
      <div className={styles.root}>
        <MaterialIcon
          icon="info"
          symbolsOutlined
          size="md-16"
          filled
          className={styles.grayIcon}
        />
        <Typography variant="label" className={styles.text}>
          {t(hintKey)}{' '}
          {isFtp && (
            <span className={styles.howItWorks}>
              <LinkComponent
                onClick={() => setHelpOpen(true)}
                size={LinkSizes.small}
                type={LinkTypes.tertiaryBlack}
                underline={false}
              >
                {t('documents-import-ftp-how-it-works')}?
              </LinkComponent>
            </span>
          )}
        </Typography>
      </div>
      {isFtp && (
        <FtpHowItWorksModal
          isOpen={isHelpOpen}
          onClose={() => setHelpOpen(false)}
        />
      )}
    </>
  );
}
